<template>
  <div id="main">
    <LayoutNavbar/>
    <router-view/>

    <button class="btn btn-primary btn-circle" id="to-top">
      <i class="fa fa-angle-up"></i>
    </button>

    <LayoutFooter/>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar.vue'
import LayoutFooter from './LayoutFooter.vue'
import Env from '../env'

export default {
  name: 'AppLayout',
  components: {
    LayoutNavbar,
    LayoutFooter
  },
  mixins: [Env],
  head: {
    title: function () {
      return {
        inner: 'Ninkashi',
        separator: '-',
        complement: 'Ninkashi'
      }
    },
    link: function () {
      return [
        { rel: 'shortcut icon', href: '/favicon.ico', sizes: '16x16', type: 'image/x-icon' },
        { rel: 'icon', href: '/favicon.ico', sizes: '16x16', type: 'image/x-icon' }
      ]
    },
    meta: function () {
      let tags = [
        { property: 'og:title', content: 'Ninkashi', id: 'og-title' },
        { property: 'og:image', content: '/img/ninkashi_logo.png', id: 'og-image' },
        { property: 'og:type', content: 'website', id: 'og-type' },
        { property: 'og:url', content: window.location.href, id: 'og-url' },
        { name: 'description', content: 'We will help you to find the best events to spend an unforgettable moment' }
      ]

      if (!this.runningOnProduction()) {
        tags.push({
          name: 'robots',
          content: 'noimageindex, nofollow, nosnippet'
        })
      }

      return tags
    }
  }
}
</script>
